export default __webpack_public_path__ + "static/yogakshema-fd899f5dbd3430d8b8ea33c2e36e0728.svg";